module.exports = __webpack_public_path__ + "img/94e492b.webp";